<template>
	<header class="header_m">
		<!-- 헤더 상단 (항상 보임) -->
		<div class="header_top">
			<div class="mobile_logo_area">
				<a @click="toRouteWithRefresh(logo_routing)"
					><img src="@/assets/images/logo.png" alt="logo"
				/></a>
			</div>

			<div class="d_flex align_items_center">
				<a class="mobile_menu_icon" @click="menuOpen">
					<img v-if="isMenuOpen === false" :src="this.menuIcon.open" alt="" />
				</a>
			</div>
		</div>

		<!-- 메뉴 오버레이 -->
		<div v-if="isMenuOpen" class="menu-overlay" @click="menuOpen"></div>

		<!-- 사이드 메뉴 -->
		<div :class="[{ is_open: isMenuOpen }, 'header_wrap']">
			<div class="scroll_y">
				<div class="d_flex align_items_center justify_between p_20">
					<menu-lang class="mr_10 language_selector icon_black"></menu-lang>

					<a
						class="m_help mr_20"
						v-if="0 && isMenuOpen"
						@click="onShowTutorial"
					>
						<img src="@/assets/images/icon/help.png" alt="help icon" />
					</a>
					<a @click="menuOpen">
						<img
							:src="this.menuIcon.close"
							alt=""
							style="width: 30px; height: 30px"
						/>
					</a>
				</div>
				<!--				로그인 여부에 따른 화면 표시-->
				<div class="login_area">
					<div v-if="!is_logged_in" class="before_login">
						<p class="mb_20">
							{{ $t('menu.login_text1') }}<br />{{ $t('menu.login_text2') }}
						</p>
						<div class="d_flex">
							<button
								@click="
									toRoute({
										name: 'auth-login',
									})
								"
								class="flex_grow mr_10 button_bg_black"
							>
								Login
							</button>
							<button
								@click="
									toRoute({
										name: 'auth-register',
									})
								"
								class="flex_grow button_bg_blue"
							>
								Sign in
							</button>
						</div>
					</div>

					<div v-else class="after_login">
						<div class="d_flex user_box">
							<div class="user_photo">
								<a>
									<img
										src="@/assets/images/v2/icon/account_circle.png"
										alt="user image"
									/>
								</a>
							</div>
							<div class="user_detail">
								<div class="d_flex align_items_center">
									<p class="user_name mr_5">
										{{ $store.state.auth.member_info.user_name }}
									</p>
								</div>
								<p class="access_date">
									{{
										$dayjs($store.state.auth.member_info.last_login).format(
											'YYYY.MM.DD HH:mm:ss',
										)
									}}
								</p>
							</div>
							<a @click.prevent="logoutHandler" class="btn_logout"
								><img :src="iconLogoutWhite" alt="logout icon"
							/></a>
						</div>
						<div class="user_menu d_flex justify_between mt_20">
							<div class="user_menu_item">
								<span class="icon SETTINGS"></span>
								<a @click="toRoute({ name: 'mypage-account' })">{{
									$t('menu.mypage-account')
								}}</a>
							</div>
							<div class="user_menu_item">
								<span class="icon CONFIRM"></span
								><a @click="toRoute({ name: 'mypage-certification' })">{{
									$t('menu.mypage-certification')
								}}</a>
							</div>
						</div>
					</div>
				</div>

				<div class="menu_tab">
					<!--          개인/기업 -->
					<div v-if="is_logged_in" class="d_flex">
						<a
							:class="[
								{ selected: !$store.state.common.isMerchant },
								'tab_item',
							]"
							@click="tabSelect(1)"
							><span>{{ $t('menu.personal') }}</span></a
						>
						<a
							:class="[
								{ selected: $store.state.common.isMerchant },
								'tab_item',
							]"
							@click="tabSelect(2)"
							><span>{{ $t('menu.merchant.merchant') }}</span></a
						>
					</div>
				</div>

				<div v-if="!$store.state.common.isMerchant">
					<!--					로그인 전 -->
					<div v-if="0 && !is_logged_in">
						<accordion>
							<accordion-item>
								<template v-slot:accordion-trigger>
									<p class="depth_1st">{{ $t('menu.personal') }}</p>
									<span class="accordion_trigger_icon"></span>
								</template>

								<template v-slot:accordion-content>
									<accordion>
										<accordion-item class="border_b_0">
											<template v-slot:accordion-trigger>
												<p class="depth_2nd">
													{{ $t('menu.personal-how') }}
												</p>
												<span class="accordion_trigger_icon"></span>
											</template>

											<template v-slot:accordion-content>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({
																name: 'personal-how-online_shopping',
																params: {},
															})
														"
														>{{ $t('menu.personal-how-online_shopping') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({ name: 'personal-how-offline_kiosk' })
														"
														>{{ $t('menu.personal-how-offline_kiosk') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a @click="toRoute({ name: 'personal-how-qr' })">{{
														$t('menu.personal-how-qr')
													}}</a>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({
																name: 'personal-how-janopay_creditcard',
															})
														"
														>{{ $t('menu.personal-how-janopay_creditcard') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({
																name: 'personal-how-trade_and_cashback',
															})
														"
														>{{ $t('menu.personal-how-trade_and_cashback') }}</a
													>
												</li>
											</template>
										</accordion-item>
									</accordion>

									<accordion>
										<accordion-item>
											<template v-slot:accordion-trigger>
												<p class="depth_2nd">
													{{ $t('menu.personal-request') }}
												</p>
												<span class="accordion_trigger_icon"></span>
											</template>

											<template v-slot:accordion-content>
												<li class="depth_2nd_link">
													<a
														@click="toRoute({ name: 'personal-request-send' })"
														>{{ $t('menu.personal-request-send') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({ name: 'personal-request-receive' })
														"
														>{{ $t('menu.personal-request-receive') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({ name: 'personal-request-deposit' })
														"
														>{{ $t('menu.personal-request-deposit') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({ name: 'personal-request-commission' })
														"
														>{{ $t('menu.personal-request-commission') }}</a
													>
												</li>
											</template>
										</accordion-item>
									</accordion>
									<accordion>
										<accordion-item>
											<template v-slot:accordion-trigger>
												<p class="depth_2nd">{{ $t('menu.personal-asset') }}</p>
												<span class="accordion_trigger_icon"></span>
											</template>

											<template v-slot:accordion-content>
												<li class="depth_2nd_link">
													<a
														@click="toRoute({ name: 'personal-asset-wallet' })"
														>{{ $t('menu.personal-asset-wallet') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="toRoute({ name: 'personal-asset-account' })"
														>{{ $t('menu.personal-asset-account') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="toRoute({ name: 'personal-asset-jpys' })"
														>{{ $t('menu.personal-asset-jpys') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="toRoute({ name: 'personal-asset-sale' })"
														>{{ $t('menu.personal-asset-sale') }}</a
													>
												</li>
												<li class="depth_2nd_link">
													<a
														@click="
															toRoute({ name: 'personal-asset-exchange' })
														"
														>{{ $t('menu.personal-asset-exchange') }}</a
													>
												</li>
											</template>
										</accordion-item>
									</accordion>
								</template>
							</accordion-item>

							<accordion>
								<accordion-item>
									<template v-slot:accordion-trigger>
										<p class="depth_1st">{{ $t('menu.business') }}</p>
										<span class="accordion_trigger_icon"></span>
									</template>

									<template v-slot:accordion-content>
										<accordion>
											<accordion-item>
												<template v-slot:accordion-trigger>
													<p class="depth_2nd">{{ $t('menu.business-how') }}</p>
													<span class="accordion_trigger_icon"></span>
												</template>

												<template v-slot:accordion-content>
													<li class="depth_2nd_link">
														<a
															@click="toRoute({ name: 'business-how-start' })"
															>{{ $t('menu.business-how-start') }}</a
														>
													</li>
													<li class="depth_2nd_link">
														<a
															@click="toRoute({ name: 'business-how-receive' })"
															>{{ $t('menu.business-how-receive') }}</a
														>
													</li>
													<li class="depth_2nd_link">
														<a @click="toRoute({ name: 'business-how-pay' })">{{
															$t('menu.business-how-pay')
														}}</a>
													</li>
													<li class="depth_2nd_link">
														<a
															@click="toRoute({ name: 'business-how-risk' })"
															>{{ $t('menu.business-how-risk') }}</a
														>
													</li>
												</template>
											</accordion-item>
										</accordion>

										<accordion>
											<accordion-item>
												<template v-slot:accordion-trigger>
													<p class="depth_2nd">
														{{ $t('menu.business-operation') }}
													</p>
													<span class="accordion_trigger_icon"></span>
												</template>

												<template v-slot:accordion-content>
													<li class="depth_2nd_link">
														<a
															@click="
																toRoute({ name: 'business-operation-corps' })
															"
															>{{ $t('menu.business-operation-corps') }}</a
														>
													</li>
													<li class="depth_2nd_link">
														<a
															@click="
																toRoute({ name: 'business-operation-platform' })
															"
															>{{ $t('menu.business-operation-platform') }}</a
														>
													</li>
													<li class="depth_2nd_link">
														<a
															@click="
																toRoute({ name: 'business-operation-pay' })
															"
															>{{ $t('menu.business-operation-pay') }}</a
														>
													</li>
													<li class="depth_2nd_link">
														<a
															@click="
																toRoute({ name: 'business-operation-global' })
															"
															>{{ $t('menu.business-operation-global') }}</a
														>
													</li>
												</template>
											</accordion-item>
										</accordion>

										<accordion>
											<accordion-item>
												<template v-slot:accordion-trigger>
													<p class="depth_2nd">
														{{ $t('menu.business-asset') }}
													</p>
													<span class="accordion_trigger_icon"></span>
												</template>

												<template v-slot:accordion-content>
													<li class="depth_2nd_link">
														<a
															@click="toRoute({ name: 'business-asset-pay' })"
															>{{ $t('menu.business-asset-pay') }}</a
														>
													</li>
												</template>
											</accordion-item>
										</accordion>
									</template>
								</accordion-item>
							</accordion>

							<div class="menu_1st">
								<a @click="toRoute({ name: 'development' })">{{
									$t('menu.development')
								}}</a>
							</div>

							<accordion>
								<accordion-item>
									<template v-slot:accordion-trigger>
										<p class="depth_1st">{{ $t('menu.cs') }}</p>
										<span class="accordion_trigger_icon"></span>
									</template>

									<template v-slot:accordion-content>
										<li class="depth_2nd_02">
											<a @click="toRoute({ name: 'notice' })">{{
												$t('cs.notice')
											}}</a>
										</li>
										<li class="depth_2nd_02">
											<a @click="toRoute({ name: 'inquiry' })">{{
												$t('cs.inquiry.inquiry')
											}}</a>
										</li>

										<li class="depth_2nd_02">
											<a @click="toRoute({ name: 'inquiry_detail' })">{{
												$t('cs.inquiry.list')
											}}</a>
										</li>
										<li class="depth_2nd_02">
											<a @click="toRoute({ name: 'faq' })">{{
												$t('cs.faq')
											}}</a>
										</li>
									</template>
								</accordion-item>
							</accordion>
						</accordion>
					</div>

					<!--          로그인 후-->
					<div v-if="1 || is_logged_in">
						<accordion>
							<accordion-item>
								<template v-slot:accordion-trigger>
									<p class="depth_1st">{{ $t('menu.pay') }}</p>
									<span class="accordion_trigger_icon"></span>
								</template>
								<template v-slot:accordion-content>
									<li class="menu_item">
										<a @click="toRoute({ name: 'pay-payment' })">{{
											$t('menu.pay-payment')
										}}</a>
									</li>
									<li class="menu_item">
										<a @click="toRoute({ name: 'pay-deposit' })">{{
											$t('menu.pay-deposit')
										}}</a>
									</li>
									<li class="menu_item">
										<a @click="toRoute({ name: 'pay-exchange' })">{{
											$t('menu.pay-exchange')
										}}</a>
									</li>
									<li class="menu_item">
										<a @click="toRoute({ name: 'pay-c2c' })">{{
											$t('menu.pay-c2c')
										}}</a>
									</li>
								</template>
							</accordion-item>
						</accordion>
						<div v-if="0" class="menu_1st">
							<a @click="toRoute({ name: 'wallet_account-assets' })">{{
								$t('menu.wallet_account')
							}}</a>
						</div>
						<!--            활동 내역-->
						<accordion>
							<accordion-item>
								<template v-slot:accordion-trigger>
									<p class="depth_1st">{{ $t('menu.activity') }}</p>
									<span class="accordion_trigger_icon"></span>
								</template>
								<template v-slot:accordion-content>
									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'activity' })">{{
											$t('menu.activity-transaction')
										}}</a>
									</li>
									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'activity-exchange' })">{{
											$t('menu.activity-exchange')
										}}</a>
									</li>
									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'activity-c2c' })">{{
											$t('menu.activity-c2c')
										}}</a>
									</li>
									<li v-if="0" class="depth_2nd_02">
										<a @click="toRoute({ name: 'activity-invoice' })">{{
											$t('menu.activity-invoice')
										}}</a>
									</li>
								</template>
							</accordion-item>
						</accordion>
						<!--						고객센터-->
						<accordion>
							<accordion-item>
								<template v-slot:accordion-trigger>
									<p class="depth_1st">{{ $t('menu.cs') }}</p>
									<span class="accordion_trigger_icon"></span>
								</template>

								<template v-slot:accordion-content>
									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'user-notice' })">{{
											$t('cs.notice')
										}}</a>
									</li>
									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'user-inquiry' })">{{
											$t('cs.inquiry.inquiry')
										}}</a>
									</li>

									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'user-inquiry_list' })">{{
											$t('cs.inquiry.list')
										}}</a>
									</li>
									<li class="depth_2nd_02">
										<a @click="toRoute({ name: 'user-faq' })">{{
											$t('cs.faq')
										}}</a>
									</li>
								</template>
							</accordion-item>
						</accordion>
						<!--						<accordion>-->
						<!--							<accordion-item>-->
						<!--								<template v-slot:accordion-trigger>-->
						<!--									<p class="depth_1st">{{ $t('menu.setting') }}</p>-->
						<!--									<span class="accordion_trigger_icon"></span>-->
						<!--								</template>-->

						<!--								<template v-slot:accordion-content>-->
						<!--									<li class="menu_item">-->
						<!--										<a @click="toRoute({ name: '' })">{{-->
						<!--											$t('menu.setting-security')-->
						<!--										}}</a>-->
						<!--									</li>-->
						<!--									<li class="menu_item">-->
						<!--										<a @click="toRoute({ name: '' })">{{-->
						<!--											$t('menu.setting-payment')-->
						<!--										}}</a>-->
						<!--									</li>-->
						<!--									<li class="menu_item">-->
						<!--										<a @click="toRoute({ name: '' })">{{-->
						<!--											$t('menu.setting-notice')-->
						<!--										}}</a>-->
						<!--									</li>-->
						<!--								</template>-->
						<!--							</accordion-item>-->
						<!--						</accordion>-->
					</div>
				</div>
				<div v-if="$store.state.common.isMerchant">
					<div class="menu_1st">
						<a @click="toRoute({ name: 'merchant-console-catalog' })">{{
							$t('menu.merchant-console-catalog')
						}}</a>
					</div>
					<div class="menu_1st">
						<a
							@click="toRoute({ name: 'merchant-console-transaction-list' })"
							>{{ $t('menu.merchant-console-transaction-list') }}</a
						>
					</div>
					<div class="menu_1st">
						<a
							@click="toRoute({ name: 'merchant-console-settlement_account' })"
							>{{ $t('menu.merchant-console-settlement_account') }}</a
						>
					</div>
					<accordion>
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p class="depth_1st">{{ $t('cs.title') }}</p>
								<span class="accordion_trigger_icon"></span>
							</template>

							<template v-slot:accordion-content>
								<li class="menu_item">
									<a @click="toRoute({ name: 'merchant-console-cs-notice' })">{{
										$t('cs.notice')
									}}</a>
								</li>
								<li class="menu_item">
									<a
										@click="toRoute({ name: 'merchant-console-cs-inquiry' })"
										>{{ $t('cs.inquiry.inquiry') }}</a
									>
								</li>
								<li class="menu_item">
									<a
										@click="
											toRoute({ name: 'merchant-console-cs-inquiry-list' })
										"
										>{{ $t('cs.inquiry.list') }}</a
									>
								</li>
								<li class="menu_item">
									<a @click="toRoute({ name: 'merchant-console-cs-faq' })">{{
										$t('cs.faq')
									}}</a>
								</li>
							</template>
						</accordion-item>
					</accordion>
					<!-- <accordion>
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p class="depth_1st">{{ $t('merchant.title6') }}</p>
								<span class="accordion_trigger_icon"></span>
							</template>

							<template v-slot:accordion-content>
								<li class="menu_item">
									<a
										@click="
											toRoute({ name: 'merchant-console-certification-kyc' })
										"
										>{{ $t('merchant.menu_2.menu5') }}</a
									>
								</li>
								<li class="menu_item">
									<a
										@click="
											toRoute({ name: 'merchant-console-certification-email' })
										"
										>{{ $t('merchant.menu_2.menu6') }}</a
									>
								</li>
								<li class="menu_item">
									<a
										@click="
											toRoute({ name: 'merchant-console-certification-otp' })
										"
										>{{ $t('merchant.menu_2.menu7') }}</a
									>
								</li>
								<li class="menu_item">
									<a
										@click="
											toRoute({
												name: 'merchant-console-certification-address',
											})
										"
										>{{ $t('merchant.menu_2.menu8') }}</a
									>
								</li>
								<li class="menu_item">
									<a
										@click="
											toRoute({
												name: 'merchant-console-certification-security',
											})
										"
										>{{ $t('merchant.menu_2.menu9') }}</a
									>
								</li>
							</template>
						</accordion-item>
					</accordion> -->
				</div>
			</div>
			<div
				class="d_flex align_items_center justify_center w100"
				style="height: 95px"
			>
				<img
					src="@/assets/images/v2/banner-m-menu.png"
					alt=""
					style="width: auto; height: 100%"
				/>
			</div>
		</div>
		<div v-if="this.showMerchantSelector" class="merchant_select_area">
			<a @click="modalMerchant = true">
				<div class="card mb_0">
					<div class="merchant_name">
						<img :src="iconManagingAuthenticationTitle" alt="" />
						{{ $store.state.auth.merchantInfo.merchant_name }}
						<p class="merchant_id">
							{{ $store.state.auth.merchantInfo.merchant_id }}
						</p>
					</div>

					<span class="trigger_icon"></span>
				</div>
			</a>
		</div>
	</header>
	<ModalViewM v-if="modalHelp" @closeModal="closeHelpModal">
		<template #title>
			<h3 class="modal_title_m">{{ $t('menu.help') }}</h3>
		</template>
		<div>
			<div class="search_area help_input">
				<input type="text" v-model="helpSearchKeyword" />
				<a class="search_icon SEARCH"> </a>
			</div>
			<!--			<div>노출되는 영역</div>-->
			<div class="help_item" v-for="(item, idx) in nowMenuHelp" :key="idx">
				<p class="mb_10">{{ $t(item.Q) }}</p>
				<p class="mb_10 fc_red">{{ $t(item.A) }}</p>
			</div>
		</div>
	</ModalViewM>
	<ModalViewM
		v-if="modalMerchant"
		add-class="merchant"
		@closeModal="modalMerchant = false"
	>
		<template #title>
			<h3 class="modal_title_m">
				{{ merchantModalTitle }}
			</h3>
		</template>
		<MerchantPickerM
			@changeMode="changeMerchantMode"
			@selectMerchant="selectMerchant"
		></MerchantPickerM>
	</ModalViewM>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>
<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import MenuLang from '@/components/Menu/Lang';
import { mapGetters } from 'vuex';
import ModalViewM from '@/components/Layout/ModalView.m';
import MerchantPickerM from '@/components/Merchant/MerchantPicker.m';
import Tutorial from '@/components/Tutorial';
import iconLogoutWhite from '@/assets/images/v2/icon/icon-logout-white.svg';
import iconManagingAuthenticationTitle from '@/assets/images/v2/icon/icon-managing-authentication-title.svg';
import '@/assets/css/header.m.css';
export default {
	name: 'header.m',
	components: {
		Accordion,
		AccordionItem,
		MenuLang,
		ModalViewM,
		MerchantPickerM,
		Tutorial,
	},
	data() {
		return {
			isMenuOpen: false,
			showTutorial: false,
			menuIcon: {
				open: require('@/assets/images/v2/icon/mobile_menu.svg'),
				close: require('@/assets/images/icon/mobile_menu_close.png'),
			},
			iconLogoutWhite,
			iconManagingAuthenticationTitle,
			isLogin: false,
			modalHelp: false,
			modalMerchant: false,
			merchantModalMode: '',
			helpSearchKeyword: '',
			helpSampleDataList: {
				'auth-dashboard': [
					{
						Q: 'help.q1',
						A: 'help.a1',
					},
					{
						Q: 'help.q2',
						A: 'help.a2',
					},
				],
				'pay-payment': [
					{
						Q: 'help.q3',
						A: 'help.a3',
					},
					{
						Q: 'help.q4',
						A: 'help.a4',
					},
				],
				'pay-deposit': [
					{
						Q: 'help.q5',
						A: 'help.a5',
					},
					{
						Q: 'help.q6',
						A: 'help.a6',
					},
				],
				'pay-contacts': [
					{
						Q: 'help.q7',
						A: 'help.a7',
					},
				],
				'wallet_account-assets': [
					{
						Q: 'help.q8',
						A: 'help.a8',
					},
					{
						Q: 'help.q9',
						A: 'help.a9',
					},
				],
				activity: [
					{
						Q: 'help.q10',
						A: 'help.a10',
					},
					{
						Q: 'help.q11',
						A: 'help.a11',
					},
				],
				'mypage-account': [
					{
						Q: 'help.q12',
						A: 'help.a12',
					},
					{
						Q: 'help.q13',
						A: 'help.a13',
					},
				],
				'mypage-data': [
					{
						Q: 'help.q14',
						A: 'help.a14',
					},
					{
						Q: 'help.q15',
						A: 'help.a15',
					},
				],
				'merchant-console-catalog': [
					{
						Q: 'help.q16',
						A: 'help.a16',
					},
					{
						Q: 'help.q17',
						A: 'help.a17',
					},
				],
				'merchant-console-transaction-list': [
					{
						Q: 'help.q18',
						A: 'help.a18',
					},
				],
				cs: [
					{
						Q: 'help.q19',
						A: 'help.a19',
					},
				],
				certification: [
					{
						Q: 'help.q20',
						A: 'help.a20',
					},
					{
						Q: 'help.q21',
						A: 'help.a21',
					},
				],
			},
		};
	},
	computed: {
		...mapGetters('auth', ['is_logged_in']),
		logo_routing() {
			if (this.is_logged_in) {
				if (this.$store.state.common.isMerchant) {
					if (!this.$route.params.merchant_seq) {
						return { name: 'auth-dashboard' };
					} else {
						return { name: 'merchant-console-catalog', ...this.$route.params };
					}
				} else {
					return { name: 'auth-dashboard' };
				}
			} else return { name: 'home' };
		},
		nowMenuHelp() {
			let result;
			if (this.$route.name.includes('cs')) {
				result = this.helpSampleDataList.cs;
			} else if (this.$route.name.includes('certification')) {
				result = this.helpSampleDataList.certification;
			} else {
				result = this.helpSampleDataList[this.$route.name];
			}
			if (!this.helpSearchKeyword) {
				return result;
			} else {
				return result.filter(item => {
					return this.$t(item.Q)
						.replaceAll(' ', '')
						.toLowerCase()
						.includes(this.helpSearchKeyword.replaceAll(' ', '').toLowerCase());
				});
			}
		},
		merchantModalTitle() {
			return this.merchantModalMode === 'select'
				? this.$t('merchant.picker.title1')
				: this.$t('merchant.picker.title2');
		},
		showMerchantSelector() {
			if (this.$route.name === 'merchant-console-catalog' && !this.isMenuOpen) {
				return true;
			} else if (
				this.$route.name === 'merchant-console-transaction-list' &&
				!this.isMenuOpen
			) {
				return true;
			} else if (
				this.$route.name === 'merchant-console-settlement_account' &&
				!this.isMenuOpen
			) {
				return true;
			} else {
				return false;
			}
		},
		currentRoute() {
			return this.$route.name;
		},
	},
	watch: {
		isMenuOpen(value) {
			if (value) {
				document.body.classList.add('menu_open');
			} else {
				document.body.classList.remove('menu_open');
			}
		},
	},
	methods: {
		menuOpen() {
			this.isMenuOpen = !this.isMenuOpen;
		},
		tabSelect(tab) {
			if (tab === 1) {
				this.toRoute({ name: 'auth-dashboard' });
			} else {
				this.modalMerchant = true;
			}
		},
		selectMerchant(obj) {
			this.toRoute(obj);
			this.$store.dispatch('auth/getMerchantInfo', obj.params.merchant_seq);
			this.modalMerchant = false;
		},
		closeHelpModal() {
			this.modalHelp = false;
			this.helpSearchKeyword = '';
		},
		logoutHandler() {
			let logout_confirm = confirm(this.$t('alert.logout'));
			if (logout_confirm) {
				this.$store.dispatch('auth/logout');
				location.href = this.$router.resolve({
					name: 'home',
				}).href;
				this.isMenuOpen = false;
			}
		},
		toRoute(obj) {
			this.isMenuOpen = false;
			this.$router.push(obj);
		},
		toRouteWithRefresh(obj) {
			this.isMenuOpen = false;
			location.href = this.$router.resolve(obj).href;
		},
		changeMerchantMode(value) {
			this.merchantModalMode = value;
		},
		onShowTutorial() {
			this.isMenuOpen = false;
			// this.showTutorial = true;
			if (this.currentRoute === 'auth-dashboard') {
				this.showTutorial = true;
			} else if (this.currentRoute === 'pay-payment') {
				this.showTutorial = true;
			} else if (this.currentRoute === 'pay-deposit') {
				this.showTutorial = true;
			} else if (this.currentRoute === 'pay-exchange') {
				this.showTutorial = true;
			} else if (this.currentRoute === 'pay-c2c') {
				this.showTutorial = true;
			} else {
				this.modalHelp = true;
			}
		},
	},
};
</script>
